(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sl-arrow').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var wrap = btn.closest('.wrap');
    var slider = wrap && wrap.querySelector('[data-slider]');
    if (!slider) return;
    var amt = Math.max(slider.clientWidth * 0.8, 260);
    slider.scrollBy({ left: btn.dataset.slide === 'next' ? amt : -amt, behavior: 'smooth' });
  });
});

  } catch(e) { console.error(e); }
})();
})();
